import type { ClientChatMessage } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';

import { ChatMessageContent } from '@/features/chats/components/ChatMessageContent';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    layout: { flexDirection: 'row-reverse' },
    speechBubble: {
      backgroundColor: theme.colors.primary,
      color: theme.colors.onPrimary,
      borderRadius: 20,
      borderBottomRightRadius: 8,
      paddingHorizontal: 16,
      paddingVertical: 8,
      marginHorizontal: 16,
      marginVertical: 8,
      flexShrink: 1,
      maxWidth: '90%'
    },
    pending: { opacity: 0.6 }
  });

type Props = {
  message: ClientChatMessage;
  pending?: boolean;
};

export const SentChatMessage: FC<Props> = ({ message, pending = false }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={[styles.layout, pending && styles.pending]}>
      <View style={styles.speechBubble}>
        <ChatMessageContent
          message={message}
          textColor={theme.colors.onTertiary}
        />
      </View>
    </View>
  );
};
